<template>
  <div class="kyc-container">
    <PageHeader :title="pageHeaderTitle"></PageHeader>
    <KYC1Auth v-if="authLevel === 1" />
    <KYC2Auth v-if="authLevel === 2" />
    <KYC3Auth v-if="authLevel === 3" />
  </div>
</template>

<script>
import KYC1Auth from './components/KYC1Auth'
import KYC2Auth from './components/KYC2Auth'
import KYC3Auth from './components/KYC3Auth'
export default {
  name: 'KYCAuth',
  components: {
    KYC1Auth,
    KYC2Auth,
    KYC3Auth
  },

  computed: {
    authLevel() {
      return +this.$route.params.authLevel
    },
    pageHeaderTitle() {
      return `KYC${this.authLevel}${this.$t('认证')}`
    }
  }
}
</script>

<style lang="less" scoped>
.kyc-container {
}
</style>
